export const environment = {
  production: true,
  apiUrl: 'https://test.atp-images-api.aspcore.net',
stripeKey: 'pk_test_51GuGvsJKaKTjXAAhgKxpQScBRfvVP1feU6AIMVsPRqSPUihMQsbK9qNqUbGp4NVfQ0207Zgr9p4XXTqiv2Ya32Ir00J66sIYGY',
ipifyApiEndPoint: 'https://api64.ipify.org/?format=json'  
};
